import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import { CampaignActions } from "./index";
import {
    FETCH_CAMPAIGN_LIST_PROGRESS,
    FETCH_CAMPAIGN_LIST_SUCCESS,
    FETCH_CAMPAIGN_LIST_FAILED,
    FETCH_CAMPAIGN_PROGRESS,
    FETCH_CAMPAIGN_SUCCESS,
    FETCH_CAMPAIGN_FAILED,
    CLEAR_CAMPAIGN_STATE,
    CLEAR_CAMPAIGN
} from "./campaign.actions";
import { initialCampaignState } from "./campaign.states";

export const campaignReducer = (
    state: IStoreState["campaign"] = initialCampaignState,
    action: CampaignActions
) => {
    switch (action.type) {
        // ==================== CAMPAIGN REDUCERS ====================
        case FETCH_CAMPAIGN_LIST_PROGRESS: {
            const newState = produce(state, (draftState) => {
                draftState.Campaign.list.loading = LoadState.InProgress;
                draftState.Campaign.list.list = [];
                draftState.Campaign.list.totalRecords = 0;
            });
            return newState;
        }
        case FETCH_CAMPAIGN_LIST_SUCCESS: {
            const { list, totalRecords } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.Campaign.list.loading = LoadState.Loaded;
                draftState.Campaign.list.list = list;
                draftState.Campaign.list.totalRecords = totalRecords;
            });
            return newState;
        }
        case FETCH_CAMPAIGN_LIST_FAILED: {
            const newState = produce(state, (draftState) => {
                draftState.Campaign.list.loading = LoadState.Failed;
                draftState.Campaign.list.list = [];
                draftState.Campaign.list.totalRecords = 0;
            });
            return newState;
        }
        case FETCH_CAMPAIGN_PROGRESS: {
            const newState = produce(state, (draftState) => {
                draftState.Campaign.data.loading = LoadState.InProgress;
                draftState.Campaign.data.data = null;
            });
            return newState;
        }
        case FETCH_CAMPAIGN_SUCCESS: {
            const { campaign } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.Campaign.data.loading = LoadState.Loaded;
                draftState.Campaign.data.data = campaign;
            });
            return newState;
        }
        case FETCH_CAMPAIGN_FAILED: {
            const { errorMessage } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.Campaign.data.loading = LoadState.Failed;
                draftState.Campaign.data.error = errorMessage;
            });
            return newState;
        }
        case CLEAR_CAMPAIGN: {
            const newState = produce(state, (draftState) => {
                draftState.Campaign.data.loading = LoadState.NotLoaded;
                draftState.Campaign.data.data = null;
            });
            return newState;
        }
        case CLEAR_CAMPAIGN_STATE: {
            const newState = produce(state, (draftState) => {
                draftState.Campaign = initialCampaignState.Campaign;
            });
            return newState;
        }
        default: {
            return state;
        }
    }
};

